import { Logger } from "./Logger";

let defaultLogger = new Logger({
  name: "app",
  level: (process?.env?.LOG_LEVEL as any) ?? "info",
  sendToSentry: false,
});

export function initLogger(
  options: { name?: string; level?: string; sendToSentry?: boolean } = {},
) {
  const level =
    (options.level as any) ?? (process?.env?.LOG_LEVEL as any) ?? "info";
  defaultLogger = new Logger({
    name: options.name ?? "app",
    level,
    sendToSentry: !!options.sendToSentry,
  });
  return defaultLogger;
}

export default defaultLogger;
